/* eslint-disable no-unused-vars */
import { Scene, Input, Math as MathPhaser, Geom, Display } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, directionHandler, randomDirection, lightstickHandler, setLastMovement } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import ButtonPressed from "../../phaser/components/buttonPressed";
import { addButtonMove } from "../../phaser/components/buttonMove";
import SettingsButton from "../../phaser/components/settingsButton";
import HealthBar from "../../phaser/components/healthBar";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let cursors;
let walls;

let characterSelected;
let enemy;
let objNames = {};
let dobleEnemy = {};
let objNamesEnemies = {};
let showDead = {};
let objEnemiesDeathSprite = {};
let footsteps;
let hearts = 3;
let totalHearts = 3;
let redHeartsObject = [];
let blackHeartsObject = [];
let gameSettings;
let hasLightstick = false;
let defaultSettings = 1;
let numberOfTouch = 0;
let instructionsHandler = 0;
let speedEnemy = 100;

let allMembers;
let allMembersFollows;
let lastCoordenates = null;


const randomPointsEnemy = [
    { x: 2675, y: 2339 }, //jiu
    { x: 3544, y: 2479 }, // sua
    { x: 3908, y: 1321 }, // handong
    { x: 2973, y: 1261 }, // yohyeon
    { x: 1909, y: 1315 }, //Dami
    { x: 359, y: 310 } //Gahyun
];

export default class Game11 extends Scene {

    constructor() {
        super({ key: "Game11" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;
        hasLightstick = false;
        redHeartsObject = [];
        blackHeartsObject = [];
        hearts = 3;
        this.firstStep = true;
        numberOfTouch = 0;
        this.events.off('buttonNext-dialogModal');
        this.startAll = false;
        setLastMovement('down');
        instructionsHandler = 0;
        speedEnemy = 100;
        this.hp = {}
        this.hasZoom = false;
        this.hasZoomEnemy = false;
        allMembers = ['jiu', 'sua', 'siyeon', 'handong', 'yoohyeon', 'dami', 'gahyeon'];
        allMembersFollows = [{ person: 'jiu', isAlive: true }, { person: 'sua', isAlive: true }, { person: 'siyeon', isAlive: true },
        { person: 'handong', isAlive: true }, { person: 'yoohyeon', isAlive: true }, { person: 'dami', isAlive: true }, { person: 'gahyeon', isAlive: true }];
        const indexCharacterSelected = allMembers.findIndex(a => a === characterSelected);
        const indexCharacterFollowsSelected = allMembersFollows.findIndex(a => a.person === characterSelected);
        allMembers.splice(indexCharacterSelected, 1);
        allMembersFollows.splice(indexCharacterFollowsSelected, 1);


    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    create() {

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            this.isPause = true;
            this.startAll = false;
        });

        this.events.on(`resume`, (data, args) => {
            this.isPause = false;
            this.sound.mute = false;
            if (args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                if (args.goHome) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true });
                }

                if (args.goStart) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {

                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });

        this.cameras.main.setBounds(0, 0, 4437);
        this.physics.world.setBounds(0, 0, 4437);

        this.ppalSong = this.sound.add(`becauseSong`, { loop: true, volume: 0.2 });

        if (gameSettings === '1') {
            this.ppalSong.play();
        }

        this.map = mapHandler(this, 'game11', false, 8, 8);

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2, volume: 0.2 });

        this.playing = false;
        walls = this.map.walls;
        walls.setScale(3);
        this.map.ground.setScale(3);

        this.object = this.map.map.createLayer('Objects', this.map.tileset, 0, 0);
        this.object.setCollisionByProperty({ collides: true });
        this.object.setScale(3);

        this.park = this.map.map.createLayer('Park', this.map.tileset, 0, 0);
        this.park.setCollisionByProperty({ collides: true });
        this.park.setScale(3);

        this.lightstick = this.physics.add.sprite(1845, 2548, 'lightstick').setVisible(false).setActive(false).setScale(3);

        objNames[characterSelected] = this.physics.add.sprite(1845, 2053, `${characterSelected}-game11`, 4);
        objNames[characterSelected].setScale(2.5);
        objNames[characterSelected].setImmovable();
        // objNames[characterSelected].setBounce(1);

        this.add.graphics()
            .lineStyle(5, 0x00ffff, 0.5)

        walkAnimation(this, `${characterSelected}-game11`);
        reposeAnimation(this, `${characterSelected}-game11`);
        turnStaticAnimation(this, `${characterSelected}-game11`);
        upStaticAnimation(this, `${characterSelected}-game11`);
        leftStaticAnimation(this, `${characterSelected}-game11`);
        rightStaticAnimation(this, `${characterSelected}-game11`);
        backStaticAnimation(this, `${characterSelected}-game11`);
        lightstickAnimation(this, `${characterSelected}-game11`);

        dobleEnemy = this.physics.add.sprite(1851, 2438, `${characterSelected}2-game11`).setActive(false).setVisible(false);
        dobleEnemy.setScale(2.5);
        dobleEnemy.setImmovable();

        walkAnimation(this, `${characterSelected}2-game11`);
        reposeAnimation(this, `${characterSelected}2-game11`);
        turnStaticAnimation(this, `${characterSelected}2-game11`);
        upStaticAnimation(this, `${characterSelected}2-game11`);
        leftStaticAnimation(this, `${characterSelected}2-game11`);
        rightStaticAnimation(this, `${characterSelected}2-game11`);
        backStaticAnimation(this, `${characterSelected}2-game11`);

        this.anims.create({
            key: `deadSpriteAnimation`,
            frames: this.anims.generateFrameNumbers('humo-game11', { start: 0, end: 16 }),
            frameRate: 7,
            repeat: -1
        });


        for (const [i, m] of allMembers.entries()) {
            objNamesEnemies[m] = this.physics.add.sprite(randomPointsEnemy[i].x, randomPointsEnemy[i].y, `${m}2-game11`);
            objNamesEnemies[m].setImmovable();
            objNamesEnemies[m].setScale(2.5);

            // walkAnimation(this, `${m}2-game11`);
            reposeAnimation(this, `${m}2-game11`);
            // turnStaticAnimation(this, `${m}2-game11`);
            // upStaticAnimation(this, `${m}2-game11`);
            // leftStaticAnimation(this, `${m}2-game11`);
            // rightStaticAnimation(this, `${m}2-game11`);
            // backStaticAnimation(this, `${m}2-game11`);
            // lightstickAnimation(this, `${m}2-game11`);

            objNamesEnemies[m].anims.play(`repose-${m}2-game11`, true);

            objEnemiesDeathSprite[m] = this.physics.add.sprite(randomPointsEnemy[i].x, randomPointsEnemy[i].y, `humo-game11`).setScale(2.5).setVisible(false);

            this.physics.add.collider(objNamesEnemies[m], walls, () => {
                randomDirection(`${m}2-game11`);
            }, null, this);
            this.physics.add.collider(objNamesEnemies[m], this.object, () => {
                randomDirection(`${m}2-game11`);
            }, null, this);

            // this.physics.add.overlap(objNamesEnemies[m], this.park, function onOverlap() {
            //     objNamesEnemies[m].setScale(1.5);
            //     objEnemiesDeathSprite[m].setScale(1.5);

            //     clearTimeout(this.timeoutTest2);
            //     this.timeoutTest2 = setTimeout(() => {
            //         objNamesEnemies[m].setScale(2.5);
            //         objEnemiesDeathSprite[m].setScale(2.5);

            //     }, 100);
            // }.bind(this),
            //     function process(sprite, tile) {
            //         return tile.collides;
            //     }
            // );

            this.hp[m] = new HealthBar(this, objNamesEnemies[m].x - 40, objNamesEnemies[m].y - 70);
            this.hp[m].setVisible(true);


            this.physics.add.overlap(objNames[characterSelected], objNamesEnemies[m],
                function onOverlap() {
                    const isAlive = allMembersFollows.find(f => f.person === m).isAlive;
                    if (isAlive) {
                        this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                         this.instructionMessage.visible = true;

                        this.countStartKill++;

                        if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                            showDead[m] = true;
                            if (this.hp[m] && this.hp[m].decrease(1)) {
                                objNamesEnemies[m].active = false;
                                objNamesEnemies[m].visible = false;
                                allMembersFollows.map(a => {
                                    if (a.person === m) {
                                        a.isAlive = false;
                                    }

                                    return a;
                                });
                                this.hp[m].setVisible(false);
                                objEnemiesDeathSprite[m].visible = false;

                                const stillAlive = allMembersFollows.find(f => f.isAlive);

                                if (!stillAlive) {
                                    this.startAll = false;
                                    dobleEnemy.setVelocity(0, 0);

                                    // this.dialogModal._createWindow(this, 'enemy-kill', null, true);
                                    this.dialogModal._createImageDialog(this, 'enemy-kill');
                                    this.showingInstruction = true;
                                    this.dialogModal.setText("Found a note. \nIt says, `What you're looking for is where you started.` \nI think I should go back to the hotel lobby, \nbut my clone is still chasing me... and now she's faster.".toUpperCase(), `${characterSelected}-hallway`, false, false)

                                }

                            }

                            setTimeout(() => {
                                objEnemiesDeathSprite[m].visible = false;
                                showDead[m] = false;
                            }, 1000);

                        }

                        clearTimeout(this.timeoutInstruction);

                        this.timeoutInstruction = setTimeout(() => {
                            this.instructionMessage.visible = false;
                        }, 100);

                    }

                }.bind(this),
                function process(sprite, tile) {
                    return tile.collides;
                }
            );

        }

        this.physics.add.overlap(objNames[characterSelected], this.lightstick,
            function onOverlap() {
                if(this.lightstick.active) {
                    this.instructionMessage.setPosition(this.screenCenterX + 140, this.screenCenterY);
                    this.instructionMessage.visible = true;
                    if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                        dobleEnemy.active = false;
                        dobleEnemy.setVelocity(0, 0)
                        this.startAll = false;
                        // objNames[characterSelected].active = false;
                        objNames[characterSelected].anims.play(`repose-${characterSelected}-game11`);
                        // this.dialogModal._createWindow(this, 'dialog-win', null, true);
                        this.dialogModal._createImageDialog(this, 'dialog-win');
                        this.showingInstruction = true;

                        this.dialogModal.setText("Great! My clone didn't catch me, and I found my lightstick".toUpperCase(), `${characterSelected}-hallway`, false, false);
    
                    }
    
                    clearTimeout(this.timeoutInstruction);
    
    
                    this.timeoutInstruction = setTimeout(() => {
                        this.instructionMessage.visible = false;
                    }, 100);

                }

            }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.collidesWalls = this.physics.add.collider(objNames[characterSelected], walls);
        this.collidesWalls = this.physics.add.collider(dobleEnemy, walls);

        this.physics.add.collider(objNames[characterSelected], this.object);
        // this.physics.add.collider(dobleEnemy, this.object);

        // this.physics.add.overlap(objNames[characterSelected], this.park, function onOverlap() {
            // if (!this.hasZoom) {
            //     this.updateRoomOverlapZoom(objNames[characterSelected])
            // }
            // clearTimeout(this.timeoutTest);
            // this.timeoutTest = setTimeout(() => {
            //     this.hasZoom = false;
            //     this.updateRoomOverlapNoZoom(objNames[characterSelected])
            // }, 100);
        // }.bind(this),
        //     function process(sprite, tile) {
        //         return tile.collides;
        //     }
        // );

        this.physics.add.collider(dobleEnemy, objNames[characterSelected], () => {
            if (dobleEnemy.active) {
                dobleEnemy.active = false;
                dobleEnemy.setVelocity(0, 0);
                objNames[characterSelected].alpha = 0.5;
                objNames[characterSelected].setTint(0xff0000);

                clearTimeout(this.timeoutColliderEnemy);
                this.timeoutColliderEnemy = setTimeout(() => {

                    this.tweens.add({
                        targets: redHeartsObject[hearts - 1],
                        alpha: 0,
                        scaleX: 0,
                        scaleY: 0,
                        ease: 'Linear',
                        duration: 200
                    });

                    var heartsTimeline = this.tweens.createTimeline();

                    heartsTimeline.add({
                        targets: blackHeartsObject[hearts - 1],
                        scaleX: 1.5,
                        scaleY: 1.5,
                        ease: 'Power1',
                        duration: 200
                    });


                    heartsTimeline.add({
                        targets: blackHeartsObject[hearts - 1],
                        scaleX: 3,
                        scaleY: 3,
                        ease: 'Power1',
                        duration: 200
                    });
                    heartsTimeline.play();
                    hearts -= 1;
                    setTimeout(() => {
                        if (hearts <= 0) {
                            this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                                if (progress === 1) {
                                    footsteps.stop();
                                    this.ppalSong.stop();
                                    this.scene.stop();
                                    if(this.joystickManager) {
                                        this.joystickManager.destroyTest();
                                        this.joystickManager = null;
                                    }
                                    this.events.off('buttonNext-dialogModal');
                                    this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 11, lastCoordenates });
                                }
                            });
                        }
                        dobleEnemy.active = true;
                        objNames[characterSelected].clearTint();
                        objNames[characterSelected].alpha = 1;

                    }, 1000);

                }, 500);

            }

        }, null, this);

        this.cameras.main.startFollow(objNames[characterSelected], true);

        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);

        window.addEventListener("blur", () => {
            this.isPause = true;
            this.buttonPause.pauseByEvent();
        });

        // document.addEventListener('visibilitychange', () => {
        //     if (document.visibilityState !== 'visible') {
        //         this.isPause = true;
        //         this.buttonPause.pauseByEvent();
        //     }
        // });

        objNames[characterSelected].anims.play(`repose-${characterSelected}-game11`);
        // this.dialogModal._createWindow(this, 'first-dialog', null, true);
        this.dialogModal._createImageDialog(this, 'first-dialog');
        this.showingInstruction = true;
        this.dialogModal.setText("This is creepy. \nThere's someone identical to me, and she doesn't seem friendly.".toUpperCase(), `${characterSelected}-hallway`, false, false)

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            let total = JSON.parse(localStorage.getItem('noL'));

            switch (data.id) {
                case 'first-dialog':
                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.setText("I feel like she wants to harm me. \nIn the distance, I see one of my members, \nbut... she's not her..".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 2:
                            this.dialogModal.setText("I think I need to get rid of the clones, \nbut I have to be careful... of myself, \nI mean, of my clone".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 3:
                            this.dialogModal.close();
                            this.startAll = true;
                            instructionsHandler = 0;
                            this.showingInstruction = false;
                            if(this.isMobile) {
                                this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game11`, 300);
                                this.joystickManager.createJoystick();
                                this.joystickManager.activate(hasLightstick);
                            }
                            this.time.addEvent({
                                delay: 10000,
                                callback: () => {
                                    if (dobleEnemy.active && speedEnemy < 300) {
                                        speedEnemy += 20;
                                    }
                                },
                                loop: true
                            })
                            dobleEnemy.setActive(true);
                            dobleEnemy.setVisible(true);
                            break;
                    }
                    break;
                case 'enemy-kill':
                    this.dialogModal.close();
                    this.startAll = true;
                    instructionsHandler = 0;
                    this.showingInstruction = false;
                    this.lightstick.setActive(true);
                    this.lightstick.setVisible(true);
                    break;
                case 'dialog-win':
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    if (total) {
                        if (!total.includes(11)) {
                            total.push(11);
                            localStorage.setItem('noL', JSON.stringify(total));

                        }
                    } else {
                        localStorage.setItem('noL', JSON.stringify([11]));
                    }

                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                        if (progress === 1) {
                            footsteps.stop();
                            this.ppalSong.stop();
                            this.scene.stop();
                            this.events.off('buttonNext-dialogModal');

                            this.scene.start(`Win`, { characterSelected: characterSelected, level: 11, lastCoordenates });
                        }
                    });
                    break;
            }

        }, this);

        if (this.isMobile) {
            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        let x = 0;
        let y = 16;
        for (let i = 0; i < totalHearts; i++) {
            if (i === 0) {
                x += 40;
            } else {
                x += 30;
            }
            blackHeartsObject.push(this.add.image(x, y, `heartBlack`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
            redHeartsObject.push(this.add.image(x, y, `heartRed`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
        }

        this.lightstickCounter = new LightstickCounter(this);
        this.instructionMessage = this.add.bitmapText(0, 20, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);
        // this.instructionMessage = this.add.text((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 50, 16, 'INTERACT: SPACEBAR', { font: "30px CustomFont", fill: "#FFF", stroke: "#101820", strokeThickness: 3 }).setVisible(false).setOrigin(1, 0).setScrollFactor(0);
        this.screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        this.screenCenterY = this.cameras.main.worldView.y + 15;

    }

    updateRoomOverlapZoom(character) {
        this.cameras.main.fade(100, 0, 0, 0, false, (cam, progress) => {
            if (progress === 1) {
                this.hasZoom = true;
                walls.setScale(1.5);
                this.map.ground.setScale(1.5);
                this.object.setScale(1.5);
                this.park.setScale(1.5);
                character.setScale(1.5);
                character.y = character.y / 2;
                character.x = character.x / 2;
                if (!this.hasZoomEnemy) {
                    dobleEnemy.setScale(1.5);
                    dobleEnemy.y = dobleEnemy.y / 2;
                    dobleEnemy.x = dobleEnemy.x / 2;
                    this.hasZoomEnemy = true;
                }
                this.cameras.main.fadeIn();

                for (const m of allMembers) {
                    objNamesEnemies[m].setScale(1.5);
                    objEnemiesDeathSprite[m].setScale(1.5);
                }
            }
        });
    }

    updateRoomOverlapNoZoom(character) {
        this.cameras.main.fade(100, 0, 0, 0, false, (cam, progress) => {
            if (progress === 1) {
                walls.setScale(3);
                this.map.ground.setScale(3);
                this.object.setScale(3);
                this.park.setScale(3);
                character.setScale(2.5);
                character.y = character.y * 2;
                character.x = character.x * 2;
                if (this.hasZoomEnemy) {
                    dobleEnemy.setScale(2.5);
                    dobleEnemy.y = dobleEnemy.y * 2;
                    dobleEnemy.x = dobleEnemy.x * 2;
                    this.hasZoomEnemy = false;
                }
                this.cameras.main.fadeIn();
                for (const m of allMembers) {
                    objNamesEnemies[m].setScale(2.5);
                    objEnemiesDeathSprite[m].setScale(2.5);
                }
            }
        });
    }

    updateCounter() {
        this.tweens.add({
            targets: redHeartsObject[hearts - 1],
            alpha: 0,
            scaleX: 0,
            scaleY: 0,
            ease: 'Linear',
            duration: 200
        });

        var heartsTimeline = this.tweens.createTimeline();

        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 1.5,
            scaleY: 1.5,
            ease: 'Power1',
            duration: 200
        });

        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 3,
            scaleY: 3,
            ease: 'Power1',
            duration: 200
        });
        heartsTimeline.play();
        hearts -= 1;
        setTimeout(() => {
            if (hearts <= 0) {
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        clearInterval(this.countdown);
                        footsteps.stop();
                        this.ppalSong.stop();
                        this.scene.stop();
                        if(this.joystickManager) {
                            this.joystickManager.destroyTest();
                            this.joystickManager = null;
                        }
                        this.events.off('buttonNext-dialogModal');
                        this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 11, lastCoordenates });
                    }
                });
            }

            objNames[characterSelected].clearTint();
            objNames[characterSelected].alpha = 1;
        }, 1000);

    }


    update() {

        if (this.startAll) {

            if (this.isMobile) {
                if(this.joystickManager) {
                    this.joystickManager.show();
                }
            } else {
                walkHandler(cursors, objNames[characterSelected], 300, `${characterSelected}-game11`, hasLightstick);
            }

            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {

                        footsteps.play();
                        this.playing = true;
                    }
                }

            } else {
                this.playing = false;
                footsteps.stop();
            }


            for (const e of allMembersFollows) {
                if (e.isAlive) {
                    if (showDead[e.person]) {
                        objEnemiesDeathSprite[e.person].setPosition(objNamesEnemies[e.person].x, objNamesEnemies[e.person].y)
                        objEnemiesDeathSprite[e.person].visible = true;
                        objEnemiesDeathSprite[e.person].anims.play(`deadSpriteAnimation`, true);
                    }

                }
            }

            if (dobleEnemy.active) {
                const angles = MathPhaser.Angle.BetweenPoints(dobleEnemy, objNames[characterSelected])
                const newAngles = MathPhaser.RadToDeg(angles);

                if (dobleEnemy.body.speed > 0) {
                    if (newAngles <= -45 && newAngles >= -135) {
                        dobleEnemy.anims.play(`up-${characterSelected}2-game11`, true);
                    } else if (newAngles <= 45 && newAngles >= -45) {
                        dobleEnemy.flipX = true
                        dobleEnemy.anims.play(`left-${characterSelected}2-game11`, true);
                    } else if (newAngles <= 135 && newAngles >= 45) {
                        dobleEnemy.anims.play(`down-${characterSelected}2-game11`, true);
                    } else if (newAngles <= 225 && newAngles >= 135) {
                        dobleEnemy.flipX = true
                        dobleEnemy.anims.play(`right-${characterSelected}2-game11`, true);
                    }

                }
                this._enemyFollows();
            }

        } else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game11`);
                    this.joystickManager.pause();
                }
            }
        }


    }

    _enemyFollows() {
        this.physics.moveToObject(dobleEnemy, objNames[characterSelected], speedEnemy);
    }

}